import { render, staticRenderFns } from "./PerformanceStarItem.vue?vue&type=template&id=3eaa49bc&scoped=true&"
import script from "./PerformanceStarItem.vue?vue&type=script&lang=js&"
export * from "./PerformanceStarItem.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceStarItem.vue?vue&type=style&index=0&id=3eaa49bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaa49bc",
  null
  
)

export default component.exports